import { api } from '../index';

export const getTransportDistances = async (
  transportPricingId?: number,
) => {
  const response = await api.get(`/transport/distances`, {
    params: transportPricingId ? { transportPricingId } : {},
  });
  return response?.data;
};

export const createTransportDistance = async ({
  pricingId,
  distanceMin,
  distanceMax,
}: {
  pricingId?: number;
  distanceMin: number;
  distanceMax: number;
}) => {
  const response = await api.post(`/transport/distances`, {
    transportPricingId: pricingId,
    distanceMin,
    distanceMax,
  });
  return response?.data;
};

export const updateTransportDistances = async (
  distances: {
    id: number;
    distanceMin: number;
    distanceMax: number;
  }[],
) => {
  const response = await api.put(`/transport/distances`, distances);
  return response?.data;
};

export const deleteTransportDistance = async (id: number) => {
  const response = await api.delete(`/transport/distances/${id}`);
  return response?.data;
};
